export default "__VITE_ASSET__ec2bc214__"